module.exports = __webpack_public_path__ + "images/mynt-sedlar.6ad7fae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/mynt-sedlar.jpg
// module id = dd42551d
// module chunks = 10 37